
import PreEntryApi from '../../assets/js/preentry'
import Uploader from './uploader'
import UploaderSingle from './uploader_single'
import { i18nHelper } from '@it-common/lbp_common'
import OnboardHeader from '../OnboardHeader'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Loading from 'vux/src/components/loading/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'


export default {
directives: {
TransferDom
},
components: {
Group,
Cell,
XInput,
XButton,
Flexbox,
FlexboxItem,
Loading,
Uploader,
UploaderSingle,
Confirm,
XDialog,
OnboardHeader
},
data () {
return {
diplomaNumber: '',
degreeNumber: '',
country_id: '47206',
id: '',
level: '',
residence_self: [],
residence_self_items: [],
residence_first: [],
residence_first_items: [],
diploma: [],
diploma_items: [],
degree: [],
degree_items: [],
resume: [],
resume_items: [],
student_card: [],
student_card_items: [],
showLoading: true,
delImageFlag: false,
hasShowPopup: { data: false },
delImageItem: { key: '', k: '', field: '' },
code: '',
show: false,
nowShowImg: '',
isBlueCollar: false,
infoEduStatus: 0,
isTrainee: '',

is_show_diploma: true,

is_show_degree: true,
job_type: 0
}
},
created () {
this.$forceUpdate()
this.id = this.$route.query.id


var localStorage = window.localStorage
this.code = localStorage.getItem('pre_code')
i18nHelper.loadLanguagePack(4159)
i18nHelper.setFixedLocale(localStorage.getItem('offer_zh'))
this.$forceUpdate()

if (!this.code || !this.id) {
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}

PreEntryApi.checkLogin(
{ id: this.id, code: this.code },
(data, meta) => {
if (data && data.isSubmit === true) {
this.$router.push({ name: 'onboard.preview', query: { id: this.id } })

}
},
err => {
this.showLoading = false
if (err === -2) {
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}
},
err => {
this.showLoading = false
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
},
err => {
this.showLoading = false
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}
)

PreEntryApi.getSubmitStatus({ id: this.id }, data => {
if (data) {
this.isBlueCollar = data.is_blue_collar
this.isTrainee = data.is_intern
this.infoEduStatus = data.info_edu_status
}
})

PreEntryApi.getStaffDetail({ id: this.id, code: this.code }, (data, meta) => {
if (data) {
this.country_id = data.country_id
this.job_type = data.job_type
this.level = data.level

this.hackReset = true
PreEntryApi.getMaterial(
{ id: this.id, code: this.code },
(data, meta) => {
if (data) {
var highestDegree = data.highestDegree
this.is_show_degree = highestDegree > 0 && highestDegree <= 4
this.is_show_diploma = true
if (highestDegree >= 10 || highestDegree === 0) {
this.is_show_diploma = false
}
this.residence_first_items = data.residence_first
this.diplomaNumber = data.diploma_number
this.degreeNumber = data.degree_number
this.residence_self_items = data.residence_self
this.diploma_items = data.diploma
this.degree_items = data.degree
this.resume_items = data.resume
this.student_card_items = data.student_card
data.residence_first ? this.formatImageItems(data.residence_first, 'residence_first') : ''
data.residence_self ? this.formatImageItems(data.residence_self, 'residence_self') : ''
data.diploma ? this.formatImageItems(data.diploma, 'diploma') : ''
data.degree ? this.formatImageItems(data.degree, 'degree') : ''
data.student_card ? this.formatImageItems(data.student_card, 'student_card') : ''
}
this.showLoading = false
},
(code, message) => {
this.showLoading = false
},
err => {
if (err === -2) {
this.showLoading = false
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
}
this.showLoading = false
},
err => {
this.showLoading = false
}
)
}
})
},
methods: {
showImg (src) {
this.nowShowImg = src
this.show = true
},
uploadCard (field) {
this.$refs[field].UploadFileType()
},

returnResumeData (res, field) {
this.resume_items = [res]
},
delImage (key, k, field) {
this.delImageItem.key = key
this.delImageItem.k = k
this.delImageItem.field = field
this.delImageFlag = true
},

sendDelImage () {
var field = this.delImageItem.field,
k = this.delImageItem.k,
key = this.delImageItem.key

this.delImageItem = { key: '', k: '', field: '' }
this[field + '_items'].splice(key * 2 + k, 1)
this[field + '_items'].splice(this[field + '_items'].length - 1, 1)

PreEntryApi.updateMaterialByField(
{
id: this.id,
code: this.code,
fieldName: field,
field: this[field + '_items']
},
(data, meta) => {
this.formatImageItems(this[field + '_items'], field)
this.delImageFlag = false
}
)
},
returnFileData (res, field) {
var imgType = ['jpg', 'jpeg', 'png', 'gif']
if (imgType.indexOf(res.extension.toLowerCase()) === -1) {
if (res.extension.toLowerCase() === 'doc' || res.extension.toLowerCase() === 'docx') {
res.src = '/static/img/word.png'
} else {
res.src = '/static/img/pdf.png'
}
}
if (this[field + '_items'].length > 0 && !this[field + '_items'][this[field + '_items'].length - 1]['id']) {
this[field + '_items'].splice(this[field + '_items'].length - 1, 1)
}

this[field + '_items'].push(res)
this.formatImageItems(this[field + '_items'], field)
},
formatImageItems (fields, fieldName) {
var src = '/static/img/y-5.png'
if (fieldName === 'residence_first') {
src = '/static/img/y-4.png'
}

if (fieldName === 'residence_self') {
src = '/static/img/y-5.png'
}

if (fieldName === 'diploma') {
src = '/static/img/y-6.png'
}

if (fieldName === 'degree') {
src = '/static/img/y-7.png'
}

if (fieldName === 'student_card') {
src = '/static/img/y-9-1.png'
}
if (!this.isZH) {
src = '/static/img/y-en.png'
}
fields.push({
id: '',
src: src,
url: '',
extension: 'png'
})

if (fields) {
this[fieldName] = []
var tempArray = []
fields.forEach(
function (item, index) {
var imgType = ['jpg', 'jpeg', 'png', 'gif']
var src = item.src
if (imgType.indexOf(item.extension.toLowerCase()) === -1) {
if (item.extension.toLowerCase() === 'doc' || item.extension.toLowerCase() === 'docx') {
src = '/static/img/word.png'
} else {
src = '/static/img/pdf.png'
}
}

tempArray.push({
id: item.id,
src: src,
url: item.url
})
if ((index + 1) % 2 === 0 && index !== 0) {
this[fieldName].push(tempArray)
tempArray = []
}
}.bind(this)
)
if (tempArray.length) {
this[fieldName].push(tempArray)
tempArray = []
}
}
},
showStep () {
this.hasShowPopup.data = !this.hasShowPopup.data
},

getIsZh (data) {
var localStorage = window.localStorage
if (data) {
localStorage.setItem('offer_zh', 'zh')

} else {
localStorage.setItem('offer_zh', 'en')

}
this.isZH = data
},
sendMaterial (returnFlag) {
PreEntryApi.changeUploadStatus({ id: this.id, code: this.code, diploma_number: this.diplomaNumber, degree_number: this.degreeNumber }, (data, meta) => {
if (returnFlag === 2) {
this.$router.push({
name: 'onboard.supplement',
query: { id: this.id }
})
} else {
this.$router.push({ name: 'onboard.list', query: { id: this.id } })
}
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/onboard/upload.vue